import * as React from "react";
import { styled } from "@mui/material";
import { ReactComponent as StarIcon } from "../assets/ratingStar.svg";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { PatientColorMap } from "patient/src/layout/patientColorMap";
//region [[ Styles ]]

const StarRatingView = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-evenly",
  cursor: "pointer",
  "& .hover > path": {
    stroke: PatientColorMap.Primary,
    fill: "white",
  },
  "& .marked": {
    stroke: PatientColorMap.Primary,
    fill: PatientColorMap.PrimaryLight,
  },
  "& .unmarked": {
    stroke: PatientColorMap.DefaultDark,
    fill: "white",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface StarRatingProps {
  onScoreChanged: (score: number) => void;
  score: number;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const StarRating = ({ score, ...props }: StarRatingProps) => {
  const [currentRatingIdx, setCurrentRatingIdx] = useState(-1);
  const [possibleRatingIdx, setPossibleRatingIdx] = useState(-1);

  const handleScoreChange = (i) => () => {
    setCurrentRatingIdx(i);
    setPossibleRatingIdx(-1);
    props.onScoreChanged(++i);
  };

  const handleMouseEnter = (i) => () => setPossibleRatingIdx(i);

  const handleMouseLeave = (i) => () => setPossibleRatingIdx(-1);

  useEffect(() => {
    setCurrentRatingIdx(score - 1);
  }, [score]);

  return (
    <StarRatingView className={"star-rating"}>
      {new Array(5).fill(0).map((_, i) => (
        <StarIcon
          onClick={handleScoreChange(i)}
          onMouseEnter={handleMouseEnter(i)}
          onMouseLeave={handleMouseLeave(i)}
          className={clsx(
            currentRatingIdx >= i ? "marked" : "unmarked",
            possibleRatingIdx >= i ? "hover" : "",
          )}
        />
      ))}
    </StarRatingView>
  );
};
